import axiosClient from '../axiosClient';

const settingAPI = {
    async getListInfo(params) {
        const url = `/setting/user`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
};

export default settingAPI;
